import { app, cart } from 'core';
import { ItemsBase, ItemsStyles } from 'ui/components';
import ComboEdit from 'ui/components/templates/Cart/ComboEdit/ComboEdit';
import CartDeleteItem from './CartDeleteItem';
import type { Combo } from 'core/domains';

export const CartItems = () => {
  const {
    data: { items = [] },
  } = cart.hooks.useCart();

  const { closeCart } = app.commands.useAppCommand();
  const { toggleDeleteItem, updateItem, toggleComboEditConfirmation } =
    cart.commands.useCartCommand();
  const { isOpen } = cart.hooks.useComboEditConfirmation();

  if (!items.length) {
    return null;
  }

  return (
    <ItemsStyles.Container>
      <ItemsBase
        items={items}
        onAmountChange={updateItem}
        onDelete={toggleDeleteItem}
        onKeepShopping={closeCart}
      />
      <CartDeleteItem onClose={toggleDeleteItem} />
      <ComboEdit
        isOpen={isOpen}
        toggleComboEdit={(productCode: Combo['data']['comboCode']) =>
          toggleComboEditConfirmation(productCode)
        }
      />
    </ItemsStyles.Container>
  );
};
